import { useSuspenseQuery } from '@apollo/client/react';
import { ShoppingListsQuery } from '@fdc/__generated__/graphql';
import { SHOPPING_LISTS } from '@fdc/federation/nz/queries/shopping-lists-query';
import { useAuth } from '@fdc/hooks/useAuth';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export const useShoppingLists = () => {
  const { isAuthenticated } = useAuth();
  const searchParams = useSearchParams();
  const isUseMock =
    process.env.NEXT_PUBLIC_MOCKING === 'true' ||
    searchParams.get('mockShoppingLists') === 'true';

  const [mockData, setMockData] = useState<ShoppingListsQuery>();

  useEffect(() => {
    if (isUseMock) {
      import('@fdc/mocks/shopping-lists').then((module) => {
        setMockData(module.mockShoppingLists);
      });
    }
  }, [isUseMock]);

  const { data, refetch } = useSuspenseQuery(SHOPPING_LISTS, {
    skip: isUseMock || !isAuthenticated,
  });

  return { data: isUseMock ? mockData : data, refetch };
};
